import { setupWorker } from 'msw';
import { authHandler } from './handlers/auth.handler';
import { chatHandler } from './handlers/chat.handler';
import { documentHandler } from './handlers/docuements';
import { knowledgeHandler } from './handlers/knowledge.handler';
import { logisticsHandler } from './handlers/logistics.handler';
import { logisticsStreamHandler } from './handlers/logisticsStream.handler';
import { organizationHandler } from './handlers/organization.handler';

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(
    ...authHandler,
    ...chatHandler,
    ...logisticsHandler,
    ...logisticsStreamHandler,
    ...knowledgeHandler,
    ...documentHandler,
    ...organizationHandler,
);
